module.exports = __webpack_public_path__ + "assets/img/blue_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blue_logo.jpg
// module id = 1921
// module chunks = 0